import { z } from "zod";
import { SECTOR_IDS } from "@frontier/content/contracts";
import { CARGO_KINDS, type RiskPrivateView } from "@frontier/content/risk";
import { MAX_CARGO_UNITS } from "@frontier/content/cargo-stacks";

export const cargoKindSchema = z.enum(CARGO_KINDS);
export const cargoLossResultSchema = z.object({
  walletLoss: z.strictObject({ credits: z.string().regex(/^(0|[1-9]\d*)$/), components: z.number().int().nonnegative() }).exactOptional(),
  deathId: z.string().min(1).max(200),
  sectorId: z.enum(SECTOR_IDS),
  lost: z.array(cargoKindSchema).max(MAX_CARGO_UNITS),
  retained: z.number().int().min(0).max(MAX_CARGO_UNITS),
  dropped: z.number().int().min(0).max(MAX_CARGO_UNITS),
  occurredAt: z.number().int().nonnegative(),
  respawnAt: z.number().int().nonnegative(),
}).strict();
export const riskStateSchema = z.object({
  lifeSeq: z.number().int().nonnegative(),
  dead: z.boolean(),
  respawnAt: z.number().int().nonnegative(),
  lastLoss: cargoLossResultSchema.nullable(),
}).strict();
export const riskPrivateViewSchema = z.object({
  runId: z.string().min(1).max(100),
  state: riskStateSchema,
  cargo: z.array(cargoKindSchema).max(MAX_CARGO_UNITS),
}).strict() satisfies z.ZodType<RiskPrivateView>;

export interface ContrabandBeacon {
  id: string;
  x: number;
  y: number;
  radius: number;
  /** Expiry in simulation seconds, comparable to WorldSnapshot.time. */
  expiresAt: number;
}
